import { userContext } from '../userManager';

export const apiPreprocessingFundProfilesFundsGet = (id, { interval, numberOfClusters }) =>
  userContext.apiCall({
    url: `/preprocessing-fund-profiles/${id}/clustered-funds`,
    qs: { interval, numberOfClusters },
  });
